<div class="row">
  <app-claimheader-component *ngIf="serviceResult !== undefined" [claimheader]="serviceResult.header"
      [openClaimsMessage]="serviceResult.openClaimsMessage"></app-claimheader-component>
</div>
<div class="row">
  <div class="col-md-4">
    <app-claimsidebar-component *ngIf="serviceResult !== undefined" [claimId]="serviceResult.header.controlNumber" [claimScreens]="serviceResult.screens" (screenId)="displayScreen($event)" (sentReportOfLoss)="onSendReportOfloss($event)"></app-claimsidebar-component>
  </div>
  <div class="col-md-8">
    <app-claimscreendetail-component *ngIf="serviceResult !== undefined" [claimId]="serviceResult.header.controlNumber" [claimScreenDetail]="selectedScreen" 
    [claimStatus]="claimStatus" [claimStatusReason]="claimStatusReason" [subCompanyCode]="subCompanyCode" (saveScreen)="refreshScreen()" (claimTransmitted)="refreshScreen($event)" 
    (claimSaved)="onSaveTransmitDetails($event)"
    (sentAck)="sentAcknowledgement($event)" (documentDeleted)="refreshScreen()" 
    (lossDateUpdated)="refreshScreen()" (cantBeTransmitted)="onCantBeTransmitted($event)"
    (policyNumberUpdated)="refreshScreen($event)" (zipCodeUpdated)="refreshScreen($event)"
    [openClaimsMessage]="serviceResult.openClaimsMessage"></app-claimscreendetail-component>
  </div>
</div>
<div class="claim-modal-backdrop" *ngIf="modalVisible" role="dialog" aria-modal="true" aria-labelledby="claim-modal-title">
  <div class="claim-modal text-center">
    <div class="claim-modal-header">
      <h4 id="claim-modal-title" class="mb-0">{{ modalHeader }}</h4>
    </div>
    <div class="claim-modal-body">
      <p class="mb-0">{{ modalText }}</p>
    </div>
    <div class="claim-modal-footer">
      <button type="button" class="btn btn-primary" (click)="closeModal()">Close</button>
    </div>
  </div>
</div>
